import ApiService from '@/services/ApiService';

class ListingRegistrationServices {
  static async getContactsBySearch(query) {
    const composedURL = `/api3/contact${query}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async searchAddress(params) {
    const queryString = new URLSearchParams(params).toString();
    const composedURL = `/api3/locations/external_address_search?${queryString}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getProperty(propertyId) {
    const composedURL = `/api3/property/${propertyId}/quick`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getListingSupervision() {
    const composedURL = '/api3/users/listing_supervision';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async postUserPreferences(payload) {
    const composedURL = '/api3/users/config';
    const response = await ApiService.post(composedURL, payload);
    return response;
  }

  static async createProperty(payload) {
    const composedURL = '/api3/properties';
    const response = await ApiService.post(composedURL, payload);
    return response;
  }

  static async getAgents() {
    const response = await ApiService.get('/api3/agent/?only_actives=true');
    return response;
  }

  static async getCharacteristicsSchema(typeId) {
    const composedURL = `/api3/properties/registration/characteristics_schema?type_id=${typeId}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getPropertyTags({ developmentId, query }) {
    const composedURL = `/api3/properties/tags_search?${query}&development_id=${developmentId}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getPropertyActiveTags({ propertyId, query }) {
    const composedURL = `/api3/properties/tags_search?${query}&property_id=${propertyId}&only_selected=true`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getAmenitiesSchema(typeId) {
    const composedURL = `/api3/properties/registration/amenities_schema?type_id=${typeId}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async updateProperty({ propertyId, payload }) {
    const composedURL = `/api3/properties/${propertyId}`;
    const response = await ApiService.patch(composedURL, payload);
    return response;
  }

  static async saveAmenities(propertyId, payload) {
    const composedURL = `/api3/properties/${propertyId}/registration/amenities`;
    const response = await ApiService.patch(composedURL, payload);
    return response;
  }

  static async saveCharacteristics(propertyId, payload) {
    const composedURL = `/api3/properties/${propertyId}/registration/characteristics/`;
    const response = await ApiService.patch(composedURL, payload);
    return response;
  }

  static async getCotizationSchema(propertyId) {
    const composedURL = `/api3/properties/${propertyId}/registration/cotization_schema`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getPricePosition({ propertyId, operation, value }) {
    const composedURL = `/api3/properties/${propertyId}/registration/cotization/price_position`;
    const response = await ApiService.post(composedURL, { operation, value });
    return response;
  }

  static async saveCotization(propertyId, payload) {
    const composedURL = `/api3/properties/${propertyId}/registration/cotization/save`;
    const response = await ApiService.patch(composedURL, payload);
    return response;
  }

  static async updatePictures({ propertyId, pictures }) {
    const composedURL = `/api3/properties/${propertyId}/pictures/`;
    const response = await ApiService.patch(composedURL, { pictures });
    return response;
  }

  static async deletePicture({ propertyId, pictureId }) {
    const composedURL = `/api3/properties/${propertyId}/pictures/${pictureId}/`;
    const response = await ApiService.delete(composedURL);
    return response;
  }

  static async uploadPictureAsync({ propertyId, file, order }) {
    const composedURL = `/api3/properties/${propertyId}/pictures/async-upload/`;
    const formData = new FormData();
    formData.append('file', file);
    if (order !== undefined && order !== null) {
      formData.append('order', order);
    }
    const response = await ApiService.post(
      composedURL,
      formData,
      undefined,
      true
    );
    return response;
  }

  static async setDevelopmentTag({ developmentId, tagId, action }) {
    const composedURL = `/development/${developmentId}/add_remove_tag?tag=${tagId}&action=${action}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async setPropertyTag({ propertyId, tagId, action }) {
    const composedURL = `/property/${propertyId}/add_remove_tag?tag=${tagId}&action=${action}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async linkPropertyToDevelopment({ propertyId, developmentId }) {
    const composedURL = `/api3/development/${developmentId}/link_property?property_id=${propertyId}`;
    const response = await ApiService.post(composedURL);
    return response;
  }

  static async unlinkPropertyFromDevelopment(propertyId) {
    const composedURL = `/api3/development/unlink_property?property_id=${propertyId}`;
    const response = await ApiService.post(composedURL);
    return response;
  }

  static async saveConstructionDate({ developmentId, month, year }) {
    // TODO: validate exact inline-edit URL for construction_date with backend before merging
    const composedURL = `/development/${developmentId}/?construction_date=:)`;
    const formData = new FormData();
    formData.append('value', `${month}|${year}`);
    const response = await ApiService.post(
      composedURL,
      formData,
      undefined,
      true
    );
    return response;
  }

  static async submitForReview(propertyId) {
    const composedURL = `/api3/properties/${propertyId}/review/submit/`;
    const response = await ApiService.post(composedURL);
    return response;
  }

  static async setDisplayOnWeb({ propertyId, value }) {
    const composedURL = `/property/${propertyId}/?display_on_web=:)`;
    const formData = new FormData();
    formData.append('value', value);
    const response = await ApiService.post(
      composedURL,
      formData,
      undefined,
      true
    );
    return response;
  }

  static async checkDuplicate(locationData) {
    const composedURL = '/api3/properties/address/duplicate_check';
    const response = await ApiService.post(composedURL, locationData);
    return response;
  }
}

export default ListingRegistrationServices;
